import { css, Select } from '@mui/material';
import styled from '@emotion/styled';
import MenuItem from '@mui/material/MenuItem';
import { colors } from 'theme/colors';

interface IStyledLanguageSelect {
  mobile: boolean;
}

export const StyledLanguageSelect = styled(Select, {
  shouldForwardProp: (prop) => prop !== 'mobile',
}) <IStyledLanguageSelect>`
  background-color: ${colors.white};
  height: 32px;
  max-height: 32px;
  width: 200px;
  padding-top: 4px;
  display: flex;

  & fieldset {
    border: 1px solid ${colors.gray400};
    border-radius: 4px;
  }

  & div {
    display: flex;
    flex-direction: row;

    & img {
      width: 20px;
      height: 20px;
      margin-right: 12px;
    }
  }

  ${(props: IStyledLanguageSelect) =>
    props.mobile &&
    css`
      width: 95%;
      margin: 0 auto;
    `}
`;

export const StyledMenuItem = styled(MenuItem)`
  & div {
    display: flex;
    flex-direction: row;

    & img {
      width: 20px;
      height: 20px;
      margin-right: 12px;
    }
  }
`;
